import addLeadingZero from './addLeadingZero.js';

var formatDate = function(dateString, format) {
  if(!dateString){
    return '';
  }
  var shortMonth = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  var longMonth = ["January", "Febuary", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  dateString = dateString.replace("+0000", "");//Remove empty timezone for work in IE
  var date = new Date(dateString);
  let dayOfMonth = date.getDate();
  dayOfMonth = addLeadingZero(dayOfMonth, 2);

  let month = date.getMonth();
  //month = addLeadingZero(month, 2);

  let year = date.getFullYear();

  let hours = date.getHours();
  hours = addLeadingZero(hours, 2);

  let minutes = date.getMinutes();
  minutes = addLeadingZero(minutes, 2);

  return format.replace("dd", dayOfMonth)
                .replace("mm", shortMonth[month])
                .replace("yyyy", year)
                .replace("hh", hours)
                .replace("MM", minutes);
}

export default formatDate;